import React from "react";



import { Row, Col, Card, CardBody, CardTitle } from "reactstrap";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import BusisnessRisk1 from "pages/AllCharts1/apex1/BusisnessRisk1";
import FinancialRisk1 from "pages/AllCharts1/apex1/FinancialRisk1";
import IndustryRisk1 from "pages/AllCharts1/apex1/IndustryRisk1";
import OverAllRisk1 from "pages/AllCharts1/apex1/OverAllRisk1";

const Apexchart1 = () => {
  document.title = "Apex Charts | Bvo -Dashboard";
  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Bvo" title="Charts" breadcrumbItem="Apex Charts" />

          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Business Operational Risk</h4>
                  <BusisnessRisk1/>
                </CardBody>
              </Card>
            </Col>

            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Business Financial Risk</h4>
                  <FinancialRisk1/>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Industry Risk</h4>
                  <IndustryRisk1/>
                </CardBody>
              </Card>
            </Col>

            <Col lg={6}>
              <Card>
                <CardBody>
                  <h4 className="card-title mb-4">Over All Business Risk</h4>
                  <OverAllRisk1/>
                </CardBody>
              </Card>
            </Col>
          </Row>
      
        </div>
      </div>
    </React.Fragment>
  );
};

export default Apexchart1;
